import { render, staticRenderFns } from "./ApplicationFooter.vue?vue&type=template&id=deece282&scoped=true"
import script from "./ApplicationFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApplicationFooter.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deece282",
  null
  
)

export default component.exports